import styled from 'styled-components';

const Spacing = styled.div`
  margin: 30px 0;
`;

const Wrapper = styled.div`
  padding: 12px;
  position: relative;
  border: 1px solid ${p => p.theme.color.gray};
  border-radius: 5px;
  width: 100%;

  @media (${p => p.theme.mq.desktop}) {
    width: 80%;
  }
`;

const Title = styled.p`
  font-weight: ${p => p.theme.fontBold};
  margin: 0;
`;

const Description = styled.p`
  margin: -4px 0 10px 0;
  font-size: 14px;
`;

const SCTextField = styled.textarea`
  font-family: inherit;
  border: 0;
  position: relative;
  outline: 0;
  resize: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 100%;
  height: 100%;
`;

export { Spacing, Wrapper, Title, Description, SCTextField };



// WEBPACK FOOTER //
// ./src/components/TextField/styles.js